import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  Heading3,
  Image,
  JustifyContent,
  Overflow,
  Text,
} from '@gousto-internal/citrus-react'
import { getDefaultImage, getSrcSet } from '../../utils'
import { getTileKeyDownHandler } from './shared'
import type { CategoryTileProps } from './shared'

export const GenericCategoryTile = ({
  title,
  imageCrops = [],
  recipeCount,
  onClick,
}: CategoryTileProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Row}
    justifyContent={JustifyContent.SpaceBetween}
    alignItems={AlignItems.Stretch}
    bg={Color.White}
    height={['85px', '85px', '85px', '133px']}
    role="button"
    tabIndex={0}
    borderRadius={1}
    boxShadow="0 1px 4px rgba(0, 0, 0, 0.08)"
    overflowX={Overflow.Hidden}
    style={{ cursor: 'pointer' }}
    data-testid="category-tile-generic"
    onClick={onClick}
    onKeyDown={getTileKeyDownHandler(onClick)}
  >
    <Box paddingH={2} paddingV={2} display={Display.Flex}>
      <Heading3 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold} size={[2, 2, 6]}>
        {title}
      </Heading3>
    </Box>
    <Box
      position={DisplayPosition.Relative}
      width={['80px', '80px', '80px', '149px']}
      height="100%"
      flexShrink={0}
    >
      <Image
        src={getDefaultImage(imageCrops)}
        srcSet={getSrcSet(imageCrops)}
        alt={title}
        height="100%"
        width="100%"
        fit="cover"
        style={{
          borderTopRightRadius: '4px',
          borderBottomRightRadius: '4px',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
      />
      <Box
        position={DisplayPosition.Absolute}
        bg={Color.ColdGrey_50}
        style={{ borderRadius: '4px' }}
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        paddingV={0.5}
        paddingH={1}
        bottom={['4px', '4px', '7px']}
        right={['4px', '4px', '7px']}
      >
        <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={[0, 0, 1]}>
          {recipeCount}
        </Text>
      </Box>
    </Box>
  </Box>
)
